import Home from "../../modules/home/pages/Home";
import SignIn from "../../modules/authenticate/pages/SignIn";
import SignUp from "../../modules/authenticate/pages/SignUp";
import NotFound from "../../ui/organisms/not-found/404";
import Unauthorized from "../../ui/organisms/not-found/Unauthorized";

export const publicRoutes = [
  { path: "/", element: <Home /> },
  { path: "/signin", element: <SignIn /> },
  { path: "/signup", element: <SignUp /> },
  { path: "/*", element: <NotFound type={"not-found"} text={null} /> },
  { path: "/unauthorized", element: <Unauthorized /> },
];
